import { useMemo } from "react";
import {
  useDashboardPageContext,
  useSelectedDay,
  useSelectedShift,
} from "utils/customHooks/genericHooks";

export function useSelectedRange() {
  const { isFullDaySelected } = useDashboardPageContext();
  const selectedShift = useSelectedShift();
  const selectedDay = useSelectedDay();
  return useMemo(
    () => (isFullDaySelected ? selectedDay : selectedShift).range,
    [isFullDaySelected, selectedDay, selectedShift]
  );
}
